// extracted by mini-css-extract-plugin
module.exports = {"button":"TopicSpeedDropdown_button__TOkIQ","section-expanded":"TopicSpeedDropdown_section-expanded__jdwJb","section-collapsed":"TopicSpeedDropdown_section-collapsed__uXQ4o"};